import { LoginActions, LoginReducerState } from './types';

const INITIAL_STATE = {
  authAction: undefined,
  authStatus: 'init',
  apiToken: undefined,
} satisfies LoginReducerState;

const loginReducer = (previousState: LoginReducerState | undefined, action: LoginActions): LoginReducerState => {
  const state: LoginReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case 'AUTH': {
      if (action.isAuthenticated) {
        return { ...state, authStatus: 'authenticated', authAction: undefined, apiToken: action.apiToken };
      }

      return { ...state, authStatus: 'anonymous', authAction: undefined, apiToken: undefined };
    }

    case 'LOGIN': {
      if (state.authStatus === 'authenticated') {
        // nothin to do
        return state;
      }

      return { ...state, authAction: 'login' };
    }

    case 'LOGOUT': {
      if (state.authStatus !== 'authenticated') {
        // nothin to do
        return state;
      }

      return { ...state, authAction: 'logout' };
    }

    case 'RESET_APP': {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};

export default loginReducer;
